import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IMyProfileFormState } from '../types';

const initialState: IMyProfileFormState = {
  profile: {},
  updateProfile: {},
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    getMyProfile(state) {
      state.profile.status = RequestStatus.RUNNING;
    },
    getMyProfileSuccess(state, action: PayloadAction<IMyProfileFormState['profile']['data']>) {
      state.profile.status = RequestStatus.SUCCESS;
      state.profile.data = action.payload;
    },
    getMyProfileFailed(state, action: PayloadAction<IRequestFailed>) {
      state.profile.status = RequestStatus.ERROR;
      state.profile.error = action.payload;
    },
    //
    updateProfile(state, action) {
      state.updateProfile.status = RequestStatus.RUNNING;
    },
    updateProfileSuccess(state, action: PayloadAction<IMyProfileFormState>) {
      state.updateProfile.status = RequestStatus.SUCCESS;
      state.updateProfile.data = action.payload;
    },
    updateProfileFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateProfile.status = RequestStatus.ERROR;
      state.updateProfile.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  getMyProfile,
  getMyProfileSuccess,
  getMyProfileFailed,
  updateProfile,
  updateProfileFailed,
  updateProfileSuccess,
} = slice.actions;
